module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/tfl_insiders_banner.74c767c2ff485acd3d2c2ce2bba9b36c.png";